var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1002 957",
    style: {
      enableBackground: "new 0 0 1002 957"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1,111.7C1,79.5,12.3,53,34.8,32.1C57.3,11.2,86.6,0.7,122.6,0.7c35.4,0,64,10.3,85.9,30.9c22.5,21.2,33.8,48.9,33.8,83 c0,30.9-10.9,56.6-32.8,77.2c-22.5,21.2-52.1,31.9-88.8,31.9h-1c-35.4,0-64-10.6-85.9-31.9S1,143.9,1,111.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 311.5,
    width: 214.3,
    height: 644.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.6,956.3h214.3v-360c0-22.5,2.6-39.9,7.7-52.1c9-21.9,22.7-40.4,41-55.5c18.3-15.1,41.3-22.7,69-22.7 c72.1,0,108.1,48.6,108.1,145.8v344.6H1001V586.6c0-95.2-22.5-167.5-67.6-216.7s-104.6-73.8-178.6-73.8c-83,0-147.7,35.7-194,107.1 v1.9h-1l1-1.9v-91.7H346.6c1.3,20.6,1.9,84.6,1.9,192.1C348.5,611.1,347.8,762,346.6,956.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.0b77022ee283da0da7ef687bbaf59704.svg";
export { ForwardRef as ReactComponent };